import { Outlet, useOutletContext } from "react-router-dom";

export default function AdminLayout() {
    const { setBaseWidth } = useOutletContext();
    setBaseWidth("99999px"); //grow as wide as possible

    return (
        <div style={{ padding: "42px 28px" }}>
            <Outlet />
        </div>
    );
}
